import React from "react";
import { Table, Button, Icon, Message, Input } from "semantic-ui-react";
import { centrosDeTipologia } from "../catalogs/tipologias";
import { useWaterBalanceT } from "../useWaterBalanceT";

// Paso 4 — Mapa de centros. Nuevo, no heredado de Agua (Guía de campo §1.2).
// La tipología precarga la estructura (qué procesos suele haber, de dónde
// reciben agua, a dónde descargan); acá se confirma o se ajusta a la planta real.
export function CentrosStep({ typology, hasLaundry, centers, onChange }) {
  const t = useWaterBalanceT();
  const precargados = typology ? centrosDeTipologia(typology, { hasLaundry }) : [];
  const lista = centers && centers.length ? centers : precargados;

  const cargarPrecargados = () => onChange(precargados.map((c) => ({ ...c })));

  const actualizar = (idx, campo, val) => {
    const next = lista.map((c, i) => (i === idx ? { ...c, [campo]: val } : c));
    onChange(next);
  };

  const agregar = () => onChange([...lista, { id: `custom_${lista.length}`, nombre: "", recibe: "", descarga: "", fluido: "proceso" }]);
  const quitar = (idx) => onChange(lista.filter((_, i) => i !== idx));

  if (!typology) {
    return <Message warning icon="warning sign" content={t("water_balance_choose_typology_first")} />;
  }

  return (
    <div className="water-balance-step">
      <h3>{t("water_balance_centers_title")}</h3>
      <Message>{t("water_balance_centers_hint")}</Message>

      {(!centers || centers.length === 0) && precargados.length > 0 && (
        <Button primary basic onClick={cargarPrecargados}>
          <Icon name="download" /> {t("water_balance_preload_centers_button")}
        </Button>
      )}

      <Table celled compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t("water_balance_col_center")}</Table.HeaderCell>
            <Table.HeaderCell>{t("water_balance_col_receives")}</Table.HeaderCell>
            <Table.HeaderCell>{t("water_balance_col_discharges")}</Table.HeaderCell>
            <Table.HeaderCell>{t("water_balance_col_fluid")}</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {lista.map((c, idx) => (
            <Table.Row key={c.id || idx}>
              <Table.Cell><Input transparent value={c.nombre} onChange={(e) => actualizar(idx, "nombre", e.target.value)} /></Table.Cell>
              <Table.Cell><Input transparent value={c.recibe || ""} onChange={(e) => actualizar(idx, "recibe", e.target.value)} /></Table.Cell>
              <Table.Cell><Input transparent value={c.descarga || ""} onChange={(e) => actualizar(idx, "descarga", e.target.value)} /></Table.Cell>
              <Table.Cell><Input transparent value={c.fluido || ""} onChange={(e) => actualizar(idx, "fluido", e.target.value)} /></Table.Cell>
              <Table.Cell><Button icon="trash" basic size="tiny" onClick={() => quitar(idx)} /></Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <Button basic onClick={agregar}><Icon name="plus" /> {t("water_balance_add_center_button")}</Button>
    </div>
  );
}

export default CentrosStep;
